import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../../services/local-storage/local-storage.service';
import { LoginService } from '../../../../services/user/login.service';

@Component({
    selector: 'anmelden-als-anderer-benutzer-zurueck-button',
    templateUrl: './anmelden-als-anderer-benutzer-zurueck-button.component.html',
    styleUrls: ['./anmelden-als-anderer-benutzer-zurueck-button.component.scss'],
})
export class AnmeldenAlsAndererBenutzerZurueckButtonComponent implements OnInit {
    isLoading = false;
    visible = false;
    constructor(
        private localStorageService: LocalStorageService,
        private router: Router,
        private loginService: LoginService,
    ) {}

    ngOnInit(): void {
        if (this.localStorageService.getSwappedUser()) {
            this.visible = true;
        }
    }

    backToOriginUser() {
        this.isLoading = true;
        const originUser = this.localStorageService.getSwappedUser();
        if (originUser) {
            // Setze Client auf null
            this.localStorageService.setCurrentClient(null, 'AnmeldenAlsAndererBenutzerZurueckButtonComponent');
            // Setze User
            this.localStorageService.setCurrentUser(originUser);
            // Setze Mandant (ersten Mandanten aus der Liste)
            if (originUser.mandanten && originUser.mandanten.length > 0) {
                this.localStorageService.setCurrentMandant(originUser.mandanten[0]);
            }

            // Session immer neu laden, damit Rechte aktualisiert werden
            this.loginService.reloadSession().subscribe({
                next: (erfolgreich: boolean) => {
                    if (erfolgreich === true) {
                        this.localStorageService.setLoggedIn(true);
                        this.localStorageService.deleteSwappedUserEntity();
                        // Seite neu laden, damit Rechte aktualisiert werden
                        location.reload();
                    } else {
                        this.isLoading = false;
                    }
                },
                error: () => {
                    this.isLoading = false;
                },
            });
        }
    }
}
